



























import Vue from "vue";
import Component from "vue-class-component";
import { Inject } from "vue-property-decorator";
import { RestClient } from "@elite/restclient";
import { KpiTileModel } from "@/models";

@Component
export default class KpiCards extends Vue {
    @Inject()
    restClient!: RestClient;

    items: KpiTileModel[] | null = null;

    async mounted() {
        const response = await this.restClient.getJson<KpiTileModel[]>(
            "/api/DashboardKpis"
        );

        if (response.status === 200 && response.data) {
            const { data } = response;

            this.items = data;
        }
    }
}
